import type {WebappLanguage} from '@cohort/shared/schema/common';
import {WEBAPP_SUPPORTED_LANGUAGES} from '@cohort/shared/schema/common';
import {Apps} from '@cohort/wallet/apps';
import type {InitOptions, ResourceLanguage} from 'i18next';
import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

// Default namespace.
export const defaultNs = 'lib';

// Initialize namespaces array with 'components'
const namespaces: string[] = ['common', 'lib', 'utils', 'layouts', 'pages', 'components'];

// All translations.
const resources: Record<WebappLanguage, ResourceLanguage> = WEBAPP_SUPPORTED_LANGUAGES.reduce(
  (acc, lang) => {
    acc[lang] = {};
    return acc;
  },
  {} as Record<WebappLanguage, ResourceLanguage>
);

for (const lang of WEBAPP_SUPPORTED_LANGUAGES) {
  // eslint-disable-next-line import/dynamic-import-chunkname
  const translationModule = await import(`./locales/${lang}.json`);

  resources[lang] = translationModule.default;
}

Apps.forEach(async app => {
  const ns = `app-${app.spec.id}`;
  Object.keys(app.locales).forEach(lang => {
    resources[lang as WebappLanguage][ns] = app.locales[lang as WebappLanguage];
  });
});

export const initI18n = (options?: InitOptions): void => {
  // eslint-disable-next-line import/no-named-as-default-member
  i18n
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
      debug: true,
      fallbackLng: WEBAPP_SUPPORTED_LANGUAGES,
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
      ns: namespaces,
      defaultNS: defaultNs,
      resources,
      ...options,
    });
};

initI18n();
